/* eslint-disable @typescript-eslint/comma-dangle */

/* eslint-disable prettier/prettier */
import type React from 'react';
import { Link } from 'react-router-dom';

import * as styles from './styles';

import { Location } from '@cobliteam/common-types';

import { Analytics } from '@cobliteam/analytics';
import MedianSpeedBanner from '@cobliteam/speeding/src/components/SpeedingPage/components/MedianSpeedBanner';

import {
  BodyText,
  CaptionDefault,
  CaptionMedium,
  colors,
  DescriptionTitle,
  DialogWithHeader,
} from '@cobliteam/base-components';

import { Button } from '@cobliteam/ui/components';

export interface InfoModalProps {
  onCancel: () => void;
}

export const InfoModal: React.FC<InfoModalProps> = ({ onCancel }) => {
  const renderColumnDescription = (name: string, description: string) => (
    <div className={styles.columnsDescriptionWrapper}>
      <DescriptionTitle>{name}</DescriptionTitle>
      <BodyText>{description}</BodyText>
    </div>
  );

  const renderSeverityDescription = (
    color: string,
    name: string,
    description: JSX.Element
  ) => (
    <div className={styles.severityContainer}>
      <div className={styles.severityTitleContainer}>
        <div className={styles.circle(color)} />
        <CaptionMedium>{name}</CaptionMedium>
      </div>
      <CaptionDefault>{description}</CaptionDefault>
    </div>
  );

  return (
    <DialogWithHeader
      maxWidth="lg"
      open
      title="Entenda o histórico de alertas"
      onClose={onCancel}
      scroll="body"
    >
      <div className={styles.container}>
        <BodyText>
          Tenha total visibilidade dos alertas de eventos que foram enviados. O
          histórico ficará salvo por um período de até 30 dias. Os alertas
          guardados obedecem as regras definidas por você nas Configurações de
          notificações e alertas. Caso não tenha definido nenhuma regra, você
          será alertado a partir das regras padrão.
          <Link
            to={{
              pathname: Location.CONFIG,
              search: 'page=alerts',
            }}
            className={styles.link}
            onClick={() =>
              Analytics.track('Clicked To Setup User Alert Settings From CTA')
            }
          >
            <Button variant="text" className={styles.settingsCta}>
              Configurar regras
            </Button>
          </Link>
        </BodyText>
        <BodyText className={styles.tableDescription}>
          Na tabela você consegue ver e filtrar os alertas recebidos e poderá
          dar atenção para as infrações mais graves que ocorreram na sua frota.
        </BodyText>
        <div className={styles.tableColumnsWrapper}>
          <div>
            {renderColumnDescription(
              'Início',
              'Data e hora de quando o alerta foi disparado.'
            )}
            {renderColumnDescription(
              'Alerta',
              'Tipo do alerta enviado: (i) Velocidade da via, (ii) Velocidade do veículo e (iii) Motor ocioso.'
            )}
            {renderColumnDescription(
              'Duração',
              'Tempo exato de ocorrência da infração'
            )}
            {renderColumnDescription(
              'Gravidade',
              'A gravidade varia de acordo com o alerta e é sinalizada pelas cores ao lado. E são disparadas quando:'
            )}
          </div>

          <div className={styles.severitiesWrapper}>
            {renderSeverityDescription(
              colors.error.hover,
              'Gravíssimo',
              <>
                <CaptionDefault>
                  O excesso de velocidade foi 51% ou mais acima do limite da via
                  ou do limite estipulado para o veículo.
                  <br />
                </CaptionDefault>
                <CaptionDefault>
                  O tempo de motor ocioso foi de 30 min ou mais.
                </CaptionDefault>
              </>
            )}
            {renderSeverityDescription(
              colors.error.default,
              'Grave',
              <>
                <CaptionDefault>
                  O excesso de velocidade foi 21% a 50% acima do limite da via
                  ou do limite estipulado para o veículo.
                  <br />
                </CaptionDefault>
                <CaptionDefault>
                  O tempo de motor ocioso foi de 10 a 29 min.
                </CaptionDefault>
              </>
            )}

            {renderSeverityDescription(
              colors.warning.default,
              'Médio ',
              <>
                <CaptionDefault>
                  O excesso de velocidade foi 1% a 20% acima do limite da via ou
                  do limite estipulado para o veículo.
                  <br />
                </CaptionDefault>
                <CaptionDefault>
                  O tempo de motor ocioso foi de 3 a 9 min.
                </CaptionDefault>
              </>
            )}
          </div>
        </div>
        <div className="mt-5">
          <MedianSpeedBanner bannerPage="alertas" onExplanationModal />
        </div>
        <div className={styles.footer}>
          <BodyText>Quer saber como os eventos são disparados?</BodyText>
          {/* TODO: ITERCOM FIX LINK  */}
          <a
            className={styles.buttonFAQ}
            href="https://intercom.help/cobli-suporte/"
            target="_blank"
            rel="noreferrer"
          >
            <Button variant="text">Acesse a central de ajuda</Button>
          </a>
        </div>
      </div>
    </DialogWithHeader>
  );
};
